import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    textarea: {
        color: '#fff',
        background: 'rgba(68,88,143,.5)',
        border: 0,
        borderRadius: '4px',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        padding: '6px',
        minWidth: '40px',
        width: '100%',
        height: '140px',
        resize: 'none',
        outline: 'none'
    },
    wrapTextarea: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '49%', 
        marginBottom: 12
    },
    wrapBlockTextarea: {
        display: 'flex', 
        justifyContent: 'space-between', 
        flexWrap: 'wrap'
    },
}))

export {
    useStyles
}